const MuiBackdrop = {
  styleOverrides: {
    root: {
      position: 'absolute',
      zIndex: '50',
      backgroundColor: '#FFFFFFE5'
    }
  }
};
export default MuiBackdrop;